import { render } from "./line-detail.vue?vue&type=template&id=1e67f39a&scoped=true"
import script from "./line-detail.vue?vue&type=script&lang=js"
export * from "./line-detail.vue?vue&type=script&lang=js"

import "./line-detail.vue?vue&type=style&index=0&id=1e67f39a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e67f39a"]])

export default __exports__